<template>
    <div class="search-short-title">
        <v-text-field
            v-model="shortTitle"
            label="Par mot-clé dans le titre des conventions"
            hide-details
            outlined
            dense
            clearable
            class="rounded-0"
        />
    </div>
</template>

<script>
export default {
    props: ["value"],
    data() {
        return {
            shortTitle: null,
        };
    },
    mounted() {
        this.shortTitle = this.value;
    },
    watch: {
        async shortTitle(value) {
            this.$emit("input", value);
        },
        value(_value) {
            this.shortTitle = _value;
        },
    },
};
</script>

<style lang="sass" scoped>
.search-short-title
    display: flex
    align-items: center
</style>
